export default __webpack_public_path__ + "static/media/office365.9a1861dd.svg";